const GEOPGRAPHY_TYPE = {
  REGION: 'region',
  PROVINCE: 'province',
  MUNICIPALITY: 'municipality',
}

module.exports = {
  GEOPGRAPHY_TYPE,
}
